export default __webpack_public_path__ + "static/Section-afa3e78531dbe7b7ea3116d33e909798.jpg";